import type { ReactNode } from 'react';
import React, { useCallback, useMemo } from 'react';
import { ExpandableGroup } from '../../expandable-group';
import type { SectionGroup } from '../../filter-section/types';
import * as S from './styles';

type Props = {
  group: SectionGroup;
  expanded: boolean;
  toggleExpanded: (id: string) => void;
  children: ReactNode;
  dark?: boolean;
};

const FilterSectionGroup = ({
  group,
  expanded,
  toggleExpanded,
  children,
  dark,
}: Props) => {
  const onToggle = useCallback(
    () => toggleExpanded(group.title),
    [toggleExpanded, group.title]
  );
  const appliedFilterCount = useMemo(
    () =>
      group.filterCount > 0 ? (
        <S.AppliedFilterCount>{group.filterCount}</S.AppliedFilterCount>
      ) : undefined,
    [group.filterCount]
  );

  return (
    <ExpandableGroup
      expanded={expanded}
      title={group.title}
      onToggle={onToggle}
      badge={appliedFilterCount}
      dark={dark}
    >
      {children}
    </ExpandableGroup>
  );
};

export default FilterSectionGroup;
